export const ConsciousStream = ({ consciousness, predictions }) => {
  const priorities = consciousness?.current_priorities || [];
  const actions = consciousness?.optimization_actions || [];
  const risks = predictions?.predictions || consciousness?.predicted_risks || [];

  return (
    <section className="jarvis-panel" data-testid="conscious-stream-panel">
      <div className="jarvis-panel-header">
        <div>
          <p className="jarvis-eyebrow">Meta control plane</p>
          <h2 className="jarvis-title" data-testid="conscious-stream-title">Conscious Stream</h2>
        </div>
        <div className="jarvis-chip" data-testid="conscious-stream-chip">{priorities.length} priorities</div>
      </div>
      <div className="jarvis-stream-grid">
        <div className="jarvis-stream-column" data-testid="conscious-priorities-column">
          <h3>Current Priorities</h3>
          {priorities.slice(0, 6).map((item, index) => (
            <div className="jarvis-stream-item" key={`${item.domain}-${index}`} data-testid={`conscious-priority-${item.domain}`}>
              <strong>{item.domain}</strong>
              <small>{item.level} · {item.reason}</small>
            </div>
          ))}
        </div>
        <div className="jarvis-stream-column" data-testid="conscious-actions-column">
          <h3>Optimization Actions</h3>
          {actions.slice(0, 6).map((item, index) => (
            <div className="jarvis-stream-item" key={`${item.action}-${index}`} data-testid={`conscious-action-${index}`}>
              <strong>{item.action}</strong>
              <small>confidence {Math.round((item.confidence || 0) * 100)}% · risk {Math.round((item.risk_score || 0) * 100)}%</small>
            </div>
          ))}
        </div>
        <div className="jarvis-stream-column" data-testid="conscious-risks-column">
          <h3>Predicted Risks</h3>
          {risks.slice(0, 6).map((item, index) => (
            <div className="jarvis-stream-item" key={`${item.type}-${index}`} data-testid={`conscious-risk-${item.type}`}>
              <strong>{item.type}</strong>
              <small>{item.message}</small>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};